import featureFlags from 'lib/featureFlags';
import styles from './MarketplaceIntro.module.css';

type Props = {
  eyebrow: string;
  title: string;
  description: string;
};

/** Page heading for Marketplace lists, with the site refresh on. */
export default function MarketplaceIntro({
  eyebrow,
  title,
  description,
}: Props) {
  if (!featureFlags.newAccountsPage()) {
    return null;
  }
  return (
    <div className={styles.Intro}>
      <span className={styles.Eyebrow}>{eyebrow}</span>
      <h1 className={styles.Title}>{title}</h1>
      <p className={styles.Description}>{description}</p>
    </div>
  );
}
